import { useState } from 'react';
import '../components/home/home.css';
import PageLayout from '../components/home/PageLayout';

const TABS = [
  { id: 'about',       label: 'About Us' },
  { id: 'founder',     label: "Founder's Message" },
  { id: 'infra',       label: 'Our Infrastructure' },
  { id: 'material',    label: 'Our Study Material' },
  { id: 'assessment',  label: 'Assessment of Students' },
  { id: 'development', label: 'Overall Development of Students' },
];

const TAB_CONTENT = {
  about: (
    <div className="sa-about-tab-content">
      <p>
        Established in 1999, Somayya Academy is the most sought-after brand amongst coaching classes in Pune.
        So far more than 50,000 students have experienced the quality education at our academy, under the
        guidance of Prof. H. M. Somayya. Today, while we are celebrating 21 years of excellence in teaching
        and guiding students, the alumnae of Somayya Academy are spreading knowledge and wisdom all over.
        From conducive eco-system to excellent faculties, from study material to overall development of the
        students, Somayya Academy is committed to give best learning experience to the students.
      </p>
      <div className="sa-about-stats">
        {[
          { num: '21+', label: 'Years of Excellence' },
          { num: '50,000+', label: 'Students Trained' },
          { num: '200+', label: 'Years Combined Faculty Experience' },
          { num: '1,000+', label: 'Students Abroad' },
        ].map(s => (
          <div key={s.label} className="sa-stat-box">
            <div className="sa-stat-num">{s.num}</div>
            <div className="sa-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  ),
  founder: (
    <div className="sa-about-tab-content">
      <div className="sa-founder-block">
        <i className="fa fa-quote-left sa-quote-icon" aria-hidden="true" />
        <p>
          On behalf of all the faculties, I assure honest, committed and in-depth delivery of subject matter
          to all the students of the academy. I am happy to share that the combined experience of all the
          faculties at Somayya Academy is more than 200 years. This becomes an exceptional advantage for the
          students who are associated with us. I welcome all the students to come and give us opportunity to
          be a part of an important journey of your life called education.
        </p>
        <p className="sa-founder-name">— H. M. Somayya</p>
      </div>
    </div>
  ),
  infra: (
    <div className="sa-about-tab-content">
      <h3>Excellent Infrastructure</h3>
      <p>
        Our well-ventilated and well-lit infrastructure with state of the art furniture creates a conducive
        environment for teaching and learning. The classrooms are equipped with modern audio-visual
        equipment to make learning more effective and engaging.
      </p>
      <ul className="sa-feature-list">
        <li><i className="fa fa-check-circle" /> Spacious, well-lit classrooms</li>
        <li><i className="fa fa-check-circle" /> Modern audio-visual equipment</li>
        <li><i className="fa fa-check-circle" /> Well-stocked library</li>
        <li><i className="fa fa-check-circle" /> Comfortable seating arrangement</li>
        <li><i className="fa fa-check-circle" /> Safe and hygienic environment</li>
      </ul>
    </div>
  ),
  material: (
    <div className="sa-about-tab-content">
      <h3>Our Study Material</h3>
      <p>
        We provide the most qualitative and enriching study material, which is prepared with utmost
        perfection. Our study material has been designed keeping in mind the examination patterns and
        the requirements of students.
      </p>
      <ul className="sa-feature-list">
        <li><i className="fa fa-check-circle" /> Comprehensive subject notes</li>
        <li><i className="fa fa-check-circle" /> Solved previous year question papers</li>
        <li><i className="fa fa-check-circle" /> Practice problem sets</li>
        <li><i className="fa fa-check-circle" /> Reference books and materials</li>
        <li><i className="fa fa-check-circle" /> Regularly updated content</li>
      </ul>
    </div>
  ),
  assessment: (
    <div className="sa-about-tab-content">
      <h3>Assessment of Students</h3>
      <p>
        We conduct regular internal tests, in order to understand and keep a track record of the performance
        and progress of the students. Our assessment methodology ensures that every student is on the right
        track and gets timely feedback to improve.
      </p>
      <ul className="sa-feature-list">
        <li><i className="fa fa-check-circle" /> Weekly internal tests</li>
        <li><i className="fa fa-check-circle" /> Chapter-wise assessments</li>
        <li><i className="fa fa-check-circle" /> Mock examinations</li>
        <li><i className="fa fa-check-circle" /> Performance tracking and feedback</li>
        <li><i className="fa fa-check-circle" /> Individual doubt-clearing sessions</li>
      </ul>
    </div>
  ),
  development: (
    <div className="sa-about-tab-content">
      <h3>Overall Development of Students</h3>
      <p>
        To bring out the potentials and inculcate values amongst students, we focus upon the overall
        development of the students. At Somayya Academy, we believe that education goes beyond textbooks —
        it shapes character, builds confidence, and prepares students for life.
      </p>
      <ul className="sa-feature-list">
        <li><i className="fa fa-check-circle" /> Communication skills development</li>
        <li><i className="fa fa-check-circle" /> Time management training</li>
        <li><i className="fa fa-check-circle" /> Career guidance and counselling</li>
        <li><i className="fa fa-check-circle" /> Personality development sessions</li>
        <li><i className="fa fa-check-circle" /> Value-based education</li>
      </ul>
    </div>
  ),
};

export default function AboutUsPage() {
  const [active, setActive] = useState('about');

  return (
    <PageLayout title="About Us" breadcrumb="About Us">
      <div className="sa-container" style={{ padding: '48px 15px' }}>
        <div className="sa-about-page-layout">
          {/* Sidebar tabs */}
          <aside className="sa-about-sidebar">
            <ul className="sa-about-tabs">
              {TABS.map(t => (
                <li key={t.id}>
                  <button
                    className={`sa-about-tab-btn${active === t.id ? ' active' : ''}`}
                    onClick={() => setActive(t.id)}
                  >
                    {t.label}
                    {active === t.id && <i className="fa fa-chevron-right" />}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          {/* Tab body */}
          <div className="sa-about-tab-body">
            {TAB_CONTENT[active]}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
